// eslint-disable-next-line import/prefer-default-export
export const BACKDROP_CLICK = 'backdropClick';
